import { isVideoEditorEditRenderCompleted } from '@app/modules/video-editions';
import {
  EnrichedVideoEditorEditListItemDto,
  FragmentSocialUploadItemDto,
} from '@app/modules/fragments/fragment.types';

/**
 * Whether a BFF fragment social upload is still waiting for source media before publish can proceed.
 *
 * Deferred edit publishes arrive as `MEDIA_URL` with an empty `data` (no `url`) while the render
 * finishes — not as `VIDEO_EDITOR_EDIT`. Fragment primary media still uses `FRAGMENT` + null
 * `mediaCompletedAt`.
 */
export function isFragmentSocialUploadWaitingForMedia(
  upload: FragmentSocialUploadItemDto,
  fragmentMediaCompletedAt: string | null,
  edits: EnrichedVideoEditorEditListItemDto[] | undefined,
): boolean {
  if (upload.status !== 'WAITING') {
    return false;
  }

  if (upload.source.type === 'FRAGMENT') {
    return fragmentMediaCompletedAt === null;
  }

  // Deferred video-editor social-publish: BFF keeps MEDIA_URL with no url until render attaches.
  if (upload.source.type === 'MEDIA_URL') {
    const url = upload.source.data?.url;
    return typeof url !== 'string' || url.length === 0;
  }

  if (upload.source.type === 'VIDEO_EDITOR_EDIT') {
    const editSource = upload.source;
    const edit = edits?.find((e) => e.id === editSource.data.editId);
    return !edit || !isVideoEditorEditRenderCompleted(edit);
  }

  return false;
}
